// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Professional Theme for Delivery Express */
:root {
  --primary-color: #2563eb;
  --primary-dark: #1d4ed8;
  --secondary-color: #64748b;
  --accent-color: #06b6d4;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --danger-color: #ef4444;
  --light-bg: #f8fafc;
  --dark-bg: #0f172a;
  --border-color: #e2e8f0;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

/* Spinning animation for real-time updates */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Table row highlighting for running pipelines */
.table-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
  border-left: 3px solid #ffc107 !important;
}

.table-warning:hover {
  background-color: rgba(255, 193, 7, 0.15) !important;
}

/* Typologie filter buttons */
.typologie-filter .btn-group .btn {
  transition: all 0.2s ease;
  border-radius: 6px !important;
  font-weight: 500;
  min-width: 80px;
}

.typologie-filter .btn-group .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
}

.typologie-filter .btn-group .btn.btn-primary {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  border-color: var(--primary-color);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.typologie-filter .btn-group .btn.btn-outline-primary {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.typologie-filter .btn-group .btn.btn-outline-primary:hover {
  background-color: var(--primary-color);
  color: white;
}

/* Mobile responsiveness for typologie filter */
@media (max-width: 768px) {
  .typologie-filter .btn-group {
    flex-direction: column;
    width: 100%;
  }
  
  .typologie-filter .btn-group .btn {
    border-radius: 6px !important;
    margin-bottom: 0.25rem;
    width: 100%;
  }
  
  .typologie-filter .d-flex.flex-column.flex-md-row {
    gap: 1rem !important;
  }
}

* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  color: var(--text-primary);
  line-height: 1.6;
}

/* Header Styles - Compact & Modern */
.header-bg {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  box-shadow: var(--shadow-md);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 1000;
  min-height: 60px;
}

.header-bg h4 {
  font-weight: 700;
  letter-spacing: -0.025em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  margin: 0;
}

.header-bg small {
  font-size: 0.75rem;
  opacity: 0.8;
}

/* Compact User Account Header Styles */
.user-account-compact {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.user-account-compact:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.compact-avatar {
  position: relative;
}

.avatar-circle-small {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.avatar-circle-small i {
  color: white;
  font-size: 1rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.compact-user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.compact-name {
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.02em;
}

.compact-role {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 0.6rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.compact-role.role-admin {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border-color: rgba(239, 68, 68, 0.3);
}

.compact-role.role-user {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border-color: rgba(59, 130, 246, 0.3);
}

.compact-role.role-viewer {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
  border-color: rgba(107, 114, 128, 0.3);
}

.compact-menu-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.compact-menu-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.compact-menu-btn i {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.9);
  transition: transform 0.3s ease;
}

.compact-menu-btn:hover i {
  transform: rotate(180deg);
}

/* Compact Dropdown Menu */
.compact-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  border: none;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 0.75rem;
  min-width: 200px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 1000;
}

.compact-dropdown-header {
  padding: 0.5rem;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.02);
  margin-bottom: 0.5rem;
}

.compact-user-details {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.compact-avatar-dropdown {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.compact-avatar-dropdown i {
  color: white;
  font-size: 1.1rem;
}

.compact-username {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--text-primary);
  margin-bottom: 0.2rem;
}

.compact-email {
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.compact-dropdown-divider {
  margin: 0.5rem 0;
  border-color: var(--border-color);
  opacity: 0.3;
  border-radius: 1px;
}

.compact-dropdown-item {
  width: 100%;
  border: none;
  background: none;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  color: var(--text-primary);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
  text-align: left;
}

.compact-dropdown-item:hover {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);
  color: var(--primary-color);
  transform: translateX(4px);
}

.compact-dropdown-item.text-danger:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%);
  color: var(--danger-color);
}

.compact-dropdown-item i {
  font-size: 0.9rem;
  width: 16px;
  text-align: center;
}

.compact-dropdown-item span {
  flex: 1 1;
}

/* Favorites Dropdown Styles */
.favorites-dropdown {
  position: relative;
}

.favorites-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.favorites-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.favorites-btn i {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
}

.favorites-btn:hover i {
  color: white;
  transform: scale(1.1);
}

.favorites-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(255, 193, 7, 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.favorites-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.75rem;
  border: none;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 0;
  min-width: 320px;
  max-width: 400px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 1000;
  overflow: hidden;
}

.favorites-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1rem 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.favorites-header h6 {
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  font-size: 0.95rem;
}

.favorites-header .btn-outline-light {
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.favorites-header .btn-outline-light:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
  transform: scale(1.05);
}

.favorites-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
}

.favorites-list {
  padding: 0.5rem;
}

.favorite-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.favorite-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffc107, #ff8c00);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.favorite-item:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-color: rgba(255, 193, 7, 0.3);
}

.favorite-item:hover::before {
  opacity: 1;
}

.favorite-item-content {
  flex: 1 1;
  min-width: 0;
}

.favorite-item-content h6 {
  color: #2c3e50;
  font-weight: 700;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}

.favorite-item-content .small {
  font-size: 0.75rem;
  line-height: 1.3;
}

.favorite-item-content .badge {
  font-size: 0.65rem;
  padding: 0.25rem 0.5rem;
  font-weight: 600;
}

.favorite-item-actions {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex-shrink: 0;
}

.favorite-item-actions .btn {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 0.8rem;
  transition: all 0.2s ease;
}

.favorite-item-actions .btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
}

.favorite-item-actions .btn-primary:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.4);
}

.favorite-item-actions .btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
  background: rgba(220, 53, 69, 0.05);
}

.favorite-item-actions .btn-outline-danger:hover {
  background: #dc3545;
  color: white;
  transform: scale(1.1);
  box-shadow: 0 4px 10px rgba(220, 53, 69, 0.3);
}

/* Favorites Sections */
.favorites-section {
  margin-bottom: 1rem;
}

.favorites-section:last-child {
  margin-bottom: 0;
}

.favorites-section-header {
  padding: 0.5rem 0.75rem;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  margin-bottom: 0.5rem;
  border-left: 3px solid;
}

.favorites-section-header h6 {
  margin: 0;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
}

/* Favorite Item Variations */
.favorite-item-star {
  border-left: 3px solid #667eea;
}

.favorite-item-star::before {
  background: linear-gradient(90deg, #667eea, #764ba2) !important;
}

.favorite-item-star:hover {
  border-color: rgba(102, 126, 234, 0.3);
}

.favorite-item-reserved {
  border-left: 3px solid #ffc107;
}

.favorite-item-reserved::before {
  background: linear-gradient(90deg, #ffc107, #ff8c00) !important;
}

.favorite-item-reserved:hover {
  border-color: rgba(255, 193, 7, 0.3);
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .user-account-compact {
    padding: 0.4rem 0.6rem;
    gap: 0.5rem;
  }
  
  .avatar-circle-small {
    width: 28px;
    height: 28px;
  }
  
  .avatar-circle-small i {
    font-size: 0.9rem;
  }
  
  .compact-name {
    font-size: 0.8rem;
  }
  
  .compact-menu-btn {
    width: 24px;
    height: 24px;
  }
  
  .compact-menu-btn i {
    font-size: 0.7rem;
  }

  .favorites-btn {
    width: 36px;
    height: 36px;
  }

  .favorites-btn i {
    font-size: 1rem;
  }

  .favorites-badge {
    width: 16px;
    height: 16px;
    font-size: 0.65rem;
  }

  .favorites-dropdown-menu {
    min-width: 280px;
    max-width: 320px;
  }

  .favorite-item {
    padding: 0.6rem;
    gap: 0.5rem;
  }

  .favorite-item-content h6 {
    font-size: 0.85rem;
  }

  .favorite-item-content .small {
    font-size: 0.7rem;
  }

  .favorite-item-actions .btn {
    width: 28px;
    height: 28px;
    font-size: 0.75rem;
  }
}

/* Enhanced Dropdown Menu */
.dropdown-menu {
  border: none;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 0.75rem;
  min-width: 220px;
  margin-top: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.dropdown-item {
  border-radius: 12px;
  padding: 0.75rem 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  color: var(--text-primary);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);
  color: var(--primary-color);
  transform: translateX(4px);
}

.dropdown-item.text-danger:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%);
  color: var(--danger-color);
}

.dropdown-item-text {
  padding: 0.75rem 1rem;
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.02);
  margin-bottom: 0.25rem;
}

.dropdown-divider {
  margin: 0.75rem 0;
  border-color: var(--border-color);
  opacity: 0.3;
  border-radius: 1px;
}

/* Main Container */
.main-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: var(--shadow-lg);
  margin: 20px;
  min-height: calc(100vh - 40px);
  overflow: hidden;
  position: relative;
  z-index: 1;
}

/* Card Styles */
.card {
  border: none;
  border-radius: 16px;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* Gradient Backgrounds */
.bg-gradient-primary {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  position: relative;
  overflow: hidden;
}

.bg-gradient-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.bg-gradient-success {
  background: linear-gradient(135deg, var(--success-color) 0%, #059669 100%);
  position: relative;
  overflow: hidden;
}

.bg-gradient-success::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

.bg-gradient-info {
  background: linear-gradient(135deg, var(--accent-color) 0%, #0891b2 100%);
  position: relative;
  overflow: hidden;
}

.bg-gradient-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  pointer-events: none;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 2rem;
}

/* Metric Cards - Enhanced for better readability and alignment */
.metric-card {
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

/* Provider breakdown styling */
.provider-breakdown {
  border-left: 2px solid rgba(255, 255, 255, 0.4);
  padding-left: 12px;
  margin-bottom: 8px;
}

.provider-total {
  margin-bottom: 6px;
}

.typology-breakdown {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.typology-breakdown .badge {
  font-size: 0.7rem;
  padding: 4px 8px;
  font-weight: 500;
}

/* Enhanced metric display */
.metric-icon {
  opacity: 0.8;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.metric-number {
  text-align: right;
}

.metric-number .display-1 {
  font-size: 4rem;
  font-weight: 900;
  line-height: 1;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
}

.metric-number .h5 {
  font-size: 1.25rem;
  font-weight: 700;
  opacity: 0.95;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.01em;
}

.metric-breakdown {
  margin-top: 1rem;
  font-size: 0.85rem;
}

.metric-breakdown .badge {
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Content Cards */
.content-card {
  height: 100%;
  min-height: 400px;
}

.content-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* Production App Items */
.production-app-item {
  transition: all 0.2s ease;
  border-radius: 8px;
}

.production-app-item:hover {
  background-color: rgba(37, 99, 235, 0.05);
  transform: translateX(4px);
}

/* Button Group Enhancements */
.btn-group .btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn-group .btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* Card Header Enhancements */
.card-header {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
  border-bottom: 1px solid rgba(37, 99, 235, 0.1);
  border-radius: 16px 16px 0 0 !important;
  padding: 1.5rem;
}

/* Enhanced Button Styles */
.btn {
  border-radius: 12px;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: none;
  box-shadow: var(--shadow-sm);
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
  color: white;
  box-shadow: 0 4px 14px 0 rgba(37, 99, 235, 0.3);
}

.btn-primary:hover {
  background: linear-gradient(135deg, var(--primary-dark) 0%, #1e40af 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px 0 rgba(37, 99, 235, 0.4);
}

.btn-success {
  background: linear-gradient(135deg, var(--success-color) 0%, #059669 100%);
  color: white;
}

.btn-warning {
  background: linear-gradient(135deg, var(--warning-color) 0%, #d97706 100%);
  color: white;
}

.btn-danger {
  background: linear-gradient(135deg, var(--danger-color) 0%, #dc2626 100%);
  color: white;
}

.btn-outline-light {
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.btn-outline-light:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
  transform: translateY(-1px);
}

/* Form Controls */
.form-control {
  border-radius: 12px;
  border: 2px solid var(--border-color);
  padding: 0.75rem 1rem;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
}

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  background: white;
}

/* Form Labels */
.form-label {
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

/* Breadcrumb */
.breadcrumb {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);
}

.breadcrumb-item a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.breadcrumb-item a:hover {
  color: var(--primary-dark);
  text-decoration: underline;
}

/* Search Results */
.search-results {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  margin-top: 1rem;
  box-shadow: var(--shadow-md);
  backdrop-filter: blur(10px);
}

/* Pipeline Status */
.pipeline-status {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.status-running {
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary-color);
  border: 1px solid rgba(37, 99, 235, 0.2);
}

.status-success {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.status-failed {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
  border: 1px solid rgba(239, 68, 68, 0.2);
}

/* Loading Spinner */
.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Microsoft Login Button */
.ms-login-btn {
  background: #2f2f2f;
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);
}

.ms-login-btn:hover {
  background: #1a1a1a;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.3);
  color: white;
}

.ms-login-btn img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

/* Dropdown Enhancements */
.dropdown {
  position: relative;
}

.dropdown-menu {
  border: none;
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 0.5rem;
  min-width: 200px;
  margin-top: 0.5rem;
}

.dropdown-item {
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  color: var(--text-primary);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dropdown-item:hover {
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary-color);
  transform: translateX(4px);
}

.dropdown-item.text-danger:hover {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.dropdown-item-text {
  padding: 0.5rem 1rem;
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
}

.dropdown-divider {
  margin: 0.5rem 0;
  border-color: var(--border-color);
  opacity: 0.5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-container {
    margin: 10px;
    border-radius: 16px;
  }
  
  .header-bg .display-6 {
    font-size: 1.5rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
}

/* Animations */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.slide-in {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

/* Icon Enhancements */
.bi {
  vertical-align: middle;
  line-height: 1;
}

/* Badge Enhancements */
.badge {
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
}

/* Enhanced Dropdown */
.dropdown-menu {
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 0.5rem;
  min-width: 200px;
  margin-top: 0.5rem;
}

.dropdown-item {
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  color: var(--text-primary);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dropdown-item:hover {
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary-color);
  transform: translateX(4px);
}

/* Footer */
.footer {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-top: 1px solid var(--border-color);
  padding: 1rem 0;
  margin-top: auto;
  text-align: center;
  color: var(--text-secondary);
  font-size: 0.875rem;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(37, 99, 235, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(37, 99, 235, 0.5);
}

/* Smart Navigation Styles */
.smart-navigation {
    padding: 0;
}

.smart-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 2.5rem;
    border-radius: 1.5rem;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    position: relative;
    overflow: hidden;
}

.smart-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    pointer-events: none;
}

.step-info {
    position: relative;
    z-index: 2;
}

.step-icon-wrapper {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.2);
}

.step-info h3 {
    color: white;
    margin: 0;
    font-weight: 700;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.step-info p {
    color: rgba(255, 255, 255, 0.8);
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.progress {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    overflow: hidden;
}

.progress-bar {
    transition: width 0.6s ease;
    border-radius: 2px;
}

.step-stats .badge {
    background: rgba(255, 255, 255, 0.2) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    font-weight: 600;
    backdrop-filter: blur(10px);
}

.smart-items-grid {
    margin-top: 2rem;
}

.smart-item-card {
    transition: all 0.3s ease;
    border-radius: 1.2rem;
    overflow: hidden;
    position: relative;
    background: white;
    border: 1px solid #e9ecef;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.smart-item-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    opacity: 0;
    transition: opacity 0.3s ease;
}

.smart-item-card:hover::before {
    opacity: 1;
}

.smart-item-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.icon-wrapper {
    transition: all 0.3s ease;
    border: 2px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.smart-item-card:hover .icon-wrapper {
    transform: scale(1.1);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.metadata-badges {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.4rem;
    margin: 1rem 0;
}

.metadata-badges .badge {
    font-weight: 600;
    padding: 0.5rem 0.8rem;
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
    line-height: 1.2;
    letter-spacing: 0.02em;
}

.metadata-badges .badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Version badge container for better organization */
.version-badge-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.version-badge-container .badge {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: help;
}

.loading-container {
    background: white;
    border-radius: 1.2rem;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    border: 1px solid #e9ecef;
}

.empty-state {
    background: white;
    border-radius: 1.2rem;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    border: 2px dashed #e9ecef;
}

.empty-state i {
    color: #adb5bd;
}

/* Enhanced card body styling */
.smart-item-card .card-body {
    padding: 1.25rem;
}

.smart-item-card h5 {
    color: #2c3e50;
    font-weight: 700;
    margin-bottom: 0.75rem;
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.smart-item-card h5 .badge {
    font-size: 0.6rem;
    padding: 0.25rem 0.5rem;
    border-radius: 12px;
    font-weight: 600;
    vertical-align: middle;
}

.smart-item-card .text-muted {
    color: #6c757d !important;
    font-weight: 500;
    line-height: 1.4;
    margin-bottom: 1rem;
}

/* Compact version info styling */
.version-info-compact {
    margin: 0.75rem 0;
}

.version-info-compact .badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
    border-radius: 12px;
    font-weight: 500;
    box-shadow: none;
    border: 1px solid #dee2e6;
    background-color: #f8f9fa;
    color: #6c757d;
    transition: all 0.2s ease;
}

.version-info-compact .badge:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
    transform: none;
    box-shadow: none;
}

/* Improved reservation status styling - More Prominent */
.reservation-status {
    margin-bottom: 1rem;
    padding: 0.5rem;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.02);
}

.reserved-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
}

.reserved-badge .badge {
    font-size: 0.75rem;
    padding: 0.5rem 0.8rem;
    font-weight: 700;
    border-radius: 25px;
    box-shadow: 0 3px 8px rgba(255, 193, 7, 0.3);
}

.reserved-badge small {
    font-size: 0.7rem;
    opacity: 0.9;
    font-weight: 600;
    color: #495057;
}

/* Enhanced button styling - Primary Actions Most Prominent */
.smart-item-card .btn {
    transition: all 0.2s ease;
    border-radius: 8px;
    font-weight: 700;
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
    letter-spacing: 0.02em;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Primary action buttons (Deploy/Select) - Most prominent */
.smart-item-card .btn-primary,
.smart-item-card .btn-success,
.smart-item-card .btn-warning,
.smart-item-card .btn-info {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    font-weight: 800;
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
}

/* Secondary action buttons (Reserve/Release) - Clear but not dominant */
.smart-item-card .btn-outline-primary,
.smart-item-card .btn-outline-secondary {
    font-weight: 600;
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
    border-width: 1.5px;
}

/* Tertiary action buttons (Mute) - Subtle */
.smart-item-card .btn-outline-danger {
    font-weight: 500;
    padding: 0.4rem 0.8rem;
    font-size: 0.7rem;
    border-width: 1px;
    opacity: 0.8;
}

.smart-item-card .btn-outline-danger:hover {
    opacity: 1;
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.smart-item-card .btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Smart header button improvements */
.smart-header .btn {
    border: 2px solid rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    color: white;
    transition: all 0.3s ease;
    position: relative;
    z-index: 2;
}

.smart-header .btn:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
    color: white;
    transform: scale(1.05);
}

/* Improved reserved app styling */
.smart-item-card.reserved-app {
    border: 2px solid #ffc107 !important;
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.05) 0%, rgba(255, 193, 7, 0.02) 100%);
    box-shadow: 0 6px 20px rgba(255, 193, 7, 0.15);
}

.smart-item-card.reserved-app::before {
    background: linear-gradient(90deg, #ffc107, #ff8c00) !important;
    opacity: 1 !important;
}

.smart-item-card.reserved-app .icon-wrapper {
    border-color: #ffc107;
    background-color: rgba(255, 193, 7, 0.1) !important;
    box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);
}

.smart-item-card.reserved-app .icon-wrapper i {
    color: #ffc107 !important;
}

.smart-item-card.reserved-app:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(255, 193, 7, 0.25);
}

/* Loading spinner improvements */
.spinner-border-sm {
    width: 0.875rem;
    height: 0.875rem;
    border-width: 0.125rem;
}

/* Responsive improvements */
@media (max-width: 768px) {
    .smart-header {
        padding: 1.5rem;
    }
    
    .smart-item-card {
        margin-bottom: 1rem;
    }
    
    .icon-wrapper {
        width: 60px !important;
        height: 60px !important;
    }
    
    .step-info h3 {
        font-size: 1.25rem;
    }
    
    .step-info p {
        font-size: 0.9rem;
    }
    
    .smart-item-card .card-body {
        padding: 1rem;
    }
    
    .metadata-badges {
        gap: 0.3rem;
    }
    
    .metadata-badges .badge {
        font-size: 0.65rem;
        padding: 0.4rem 0.6rem;
    }
    
    .smart-item-card .btn {
        font-size: 0.75rem;
        padding: 0.4rem 0.8rem;
    }
    
    .smart-item-card .btn-primary,
    .smart-item-card .btn-success,
    .smart-item-card .btn-warning,
    .smart-item-card .btn-info {
        font-size: 0.8rem;
        padding: 0.5rem 1rem;
    }
    
    .reserved-badge .badge {
        font-size: 0.7rem;
        padding: 0.4rem 0.7rem;
    }
    
    .d-flex.flex-wrap {
        gap: 0.5rem !important;
    }
    
    .btn-sm {
        font-size: 0.7rem;
        padding: 0.25rem 0.5rem;
    }
}

/* App Type Filter Toggle Styles */
.btn-group .btn-check:checked + .btn-outline-primary {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    color: white;
    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);
}

.btn-group .btn-outline-primary {
    border-color: var(--border-color);
    color: var(--text-secondary);
    transition: all 0.2s ease;
}

.btn-group .btn-outline-primary:hover {
    background-color: rgba(37, 99, 235, 0.1);
    border-color: var(--primary-color);
    color: var(--primary-color);
}

.btn-group .btn-outline-primary:active {
    transform: scale(0.98);
}

/* Navigation App Type Filter Toggle Styles */
.smart-header .btn-group .btn-check:checked + .btn-outline-light {
    background-color: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 255, 255, 0.2);
}

.smart-header .btn-group .btn-outline-light {
    border-color: rgba(255, 255, 255, 0.3);
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.2s ease;
    font-size: 0.75rem;
    padding: 0.375rem 0.75rem;
}

.smart-header .btn-group .btn-outline-light:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.5);
    color: white;
}

.smart-header .btn-group .btn-outline-light:active {
    transform: scale(0.98);
}

/* Chart Styles */
.chart-container {
    position: relative;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
}

.chart-container canvas {
    border-radius: 8px;
}

.metric-card .chart-container {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Sophisticated Metric Card Design */
.metric-card {
    position: relative;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border: none;
}

.metric-card:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.metric-card-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    opacity: 0.7;
    transition: all 0.4s ease;
}

.metric-card:hover .metric-card-bg {
    opacity: 1;
    transform: scale(1.05);
}

.metric-card-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.metric-header {
    flex-shrink: 0;
}

.metric-breakdown {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 0.75rem;
}

/* Alignement uniforme des éléments */
.metric-icon-wrapper {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.metric-number {
    text-align: right;
    min-width: 120px;
}

.metric-number .display-3 {
    font-size: 3rem;
    line-height: 1;
    margin-bottom: 0.25rem;
}

.metric-number .h6 {
    font-size: 0.875rem;
    margin-bottom: 0;
}

/* Alignement des sections de breakdown */
.breakdown-section {
    margin-bottom: 0.75rem !important;
}

.breakdown-section:last-child {
    margin-bottom: 0 !important;
}

/* Alignement des compteurs */
.metric-counter {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 60px;
    padding: 0.5rem;
}

.metric-counter .h6 {
    margin-bottom: 0.25rem;
    font-size: 1rem;
    font-weight: 700;
}

.metric-counter .small {
    font-size: 0.75rem;
    margin-bottom: 0;
    font-weight: 600;
}

/* Espacement uniforme des grilles */
.metric-breakdown .row {
    margin: 0;
}

.metric-breakdown .col-4 {
    padding: 0 0.25rem;
}

.metric-icon-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
}

.metric-card:hover .metric-icon-wrapper {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
    transform: scale(1.1);
}

.metric-icon-wrapper i {
    color: white;
    font-size: 2.5rem;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
}

.metric-card:hover .metric-icon-wrapper i {
    transform: scale(1.1);
}

/* Card-specific variations - Professional Theme */
.metric-card-deployments .metric-card-bg {
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
}

.metric-card-providers .metric-card-bg {
    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.metric-card-apps .metric-card-bg {
    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
}

/* Enhanced metric display */
.metric-number .display-1 {
    font-size: 4.5rem;
    font-weight: 900;
    line-height: 1;
    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
    margin-bottom: 0.5rem;
    letter-spacing: -0.02em;
    background: linear-gradient(45deg, #ffffff, #f0f0f0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.metric-number .h5 {
    font-size: 1.25rem;
    font-weight: 700;
    opacity: 0.95;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    letter-spacing: 0.01em;
}

/* Metric breakdown styling */
.metric-breakdown {
    margin-top: 1.5rem;
    font-size: 0.85rem;
}

.breakdown-section {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.breakdown-section:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    background: rgba(255, 255, 255, 1) !important;
}

.metric-counter {
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.metric-counter:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;AACjF;;AAEA,6CAA6C;AAC7C;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;EACE,mDAAmD;EACnD,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;AACtD;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,sFAAsF;EACtF,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yFAAyF;EACzF,6DAA6D;EAC7D,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,sFAAsF;EACtF,4BAA4B;EAC5B,iDAAiD;EACjD,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+FAA+F;EAC/F,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,0CAA0C;EAC1C,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,qFAAqF;EACrF,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4FAA4F;EAC5F,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4FAA4F;EAC5F,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qFAAqF;EACrF,qCAAqC;EACrC,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,oCAAoC;AACtC;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,mBAAmB;EACnB,qFAAqF;EACrF,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4FAA4F;EAC5F,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4FAA4F;EAC5F,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,sFAAsF;EACtF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,oBAAoB;AACtB;;AAEA;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,oBAAoB;AACtB;;AAEA;EACE,yEAAyE;EACzE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,4FAA4F;EAC5F,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,qFAAqF;AACvF;;AAEA,+BAA+B;AAC/B;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,6BAA6B;AAC7B;EACE,8FAA8F;EAC9F,+CAA+C;EAC/C,uCAAuC;EACvC,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sFAAsF;EACtF,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,yEAAyE;EACzE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,0EAA0E;EAC1E,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,YAAY;AACd;;AAEA;EACE,yEAAyE;EACzE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA,eAAe;AACf;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,mBAAmB;EACnB,mFAAmF;EACnF,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;IACI,UAAU;AACd;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+FAA+F;IAC/F,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,0CAA0C;IAC1C,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,oDAAoD;IACpD,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA,6DAA6D;AAC7D;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA,4DAA4D;AAC5D;;;;IAII,yCAAyC;IACzC,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,wEAAwE;AACxE;;IAEI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA,qCAAqC;AACrC;IACI,0CAA0C;IAC1C,oCAAoC;IACpC,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,oCAAoC;IACpC,6FAA6F;IAC7F,8CAA8C;AAClD;;AAEA;IACI,+DAA+D;IAC/D,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mDAAmD;IACnD,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,4BAA4B;AAC5B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;;;;QAII,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;AACJ;;AAEA,kCAAkC;AAClC;IACI,sCAAsC;IACtC,kCAAkC;IAClC,YAAY;IACZ,4CAA4C;AAChD;;AAEA;IACI,iCAAiC;IACjC,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,6CAA6C;AAC7C;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iDAAiD;IACjD,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,6DAA6D;IAC7D,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,6BAA6B;AAC7B;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,kDAAkD;AAClD;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;IACzC,qBAAqB;IACrB,uBAAuB;IACvB,oDAAoD;IACpD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;IAChD,2BAA2B;IAC3B,oCAAoC;IACpC,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C","sourcesContent":["/* Modern Professional Theme for Delivery Express */\n:root {\n  --primary-color: #2563eb;\n  --primary-dark: #1d4ed8;\n  --secondary-color: #64748b;\n  --accent-color: #06b6d4;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --danger-color: #ef4444;\n  --light-bg: #f8fafc;\n  --dark-bg: #0f172a;\n  --border-color: #e2e8f0;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n}\n\n/* Spinning animation for real-time updates */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Table row highlighting for running pipelines */\n.table-warning {\n  background-color: rgba(255, 193, 7, 0.1) !important;\n  border-left: 3px solid #ffc107 !important;\n}\n\n.table-warning:hover {\n  background-color: rgba(255, 193, 7, 0.15) !important;\n}\n\n/* Typologie filter buttons */\n.typologie-filter .btn-group .btn {\n  transition: all 0.2s ease;\n  border-radius: 6px !important;\n  font-weight: 500;\n  min-width: 80px;\n}\n\n.typologie-filter .btn-group .btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);\n}\n\n.typologie-filter .btn-group .btn.btn-primary {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  border-color: var(--primary-color);\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);\n}\n\n.typologie-filter .btn-group .btn.btn-outline-primary {\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.typologie-filter .btn-group .btn.btn-outline-primary:hover {\n  background-color: var(--primary-color);\n  color: white;\n}\n\n/* Mobile responsiveness for typologie filter */\n@media (max-width: 768px) {\n  .typologie-filter .btn-group {\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .typologie-filter .btn-group .btn {\n    border-radius: 6px !important;\n    margin-bottom: 0.25rem;\n    width: 100%;\n  }\n  \n  .typologie-filter .d-flex.flex-column.flex-md-row {\n    gap: 1rem !important;\n  }\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: 100vh;\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\n/* Header Styles - Compact & Modern */\n.header-bg {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  box-shadow: var(--shadow-md);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  position: relative;\n  z-index: 1000;\n  min-height: 60px;\n}\n\n.header-bg h4 {\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  margin: 0;\n}\n\n.header-bg small {\n  font-size: 0.75rem;\n  opacity: 0.8;\n}\n\n/* Compact User Account Header Styles */\n.user-account-compact {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 25px;\n  padding: 0.5rem 0.75rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.user-account-compact:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n.compact-avatar {\n  position: relative;\n}\n\n.avatar-circle-small {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  transition: all 0.3s ease;\n}\n\n.avatar-circle-small i {\n  color: white;\n  font-size: 1rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.compact-user-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.compact-name {\n  color: white;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  letter-spacing: 0.02em;\n}\n\n.compact-role {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 0.6rem;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.compact-role.role-admin {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.compact-role.role-user {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  border-color: rgba(59, 130, 246, 0.3);\n}\n\n.compact-role.role-viewer {\n  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);\n  color: white;\n  border-color: rgba(107, 114, 128, 0.3);\n}\n\n.compact-menu-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.compact-menu-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\n.compact-menu-btn i {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.9);\n  transition: transform 0.3s ease;\n}\n\n.compact-menu-btn:hover i {\n  transform: rotate(180deg);\n}\n\n/* Compact Dropdown Menu */\n.compact-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.5rem;\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: 0.75rem;\n  min-width: 200px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 1000;\n}\n\n.compact-dropdown-header {\n  padding: 0.5rem;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.02);\n  margin-bottom: 0.5rem;\n}\n\n.compact-user-details {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.compact-avatar-dropdown {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.compact-avatar-dropdown i {\n  color: white;\n  font-size: 1.1rem;\n}\n\n.compact-username {\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  margin-bottom: 0.2rem;\n}\n\n.compact-email {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.compact-dropdown-divider {\n  margin: 0.5rem 0;\n  border-color: var(--border-color);\n  opacity: 0.3;\n  border-radius: 1px;\n}\n\n.compact-dropdown-item {\n  width: 100%;\n  border: none;\n  background: none;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  color: var(--text-primary);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.25rem;\n  text-align: left;\n}\n\n.compact-dropdown-item:hover {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);\n  color: var(--primary-color);\n  transform: translateX(4px);\n}\n\n.compact-dropdown-item.text-danger:hover {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%);\n  color: var(--danger-color);\n}\n\n.compact-dropdown-item i {\n  font-size: 0.9rem;\n  width: 16px;\n  text-align: center;\n}\n\n.compact-dropdown-item span {\n  flex: 1;\n}\n\n/* Favorites Dropdown Styles */\n.favorites-dropdown {\n  position: relative;\n}\n\n.favorites-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.favorites-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\n.favorites-btn i {\n  font-size: 1.1rem;\n  color: rgba(255, 255, 255, 0.9);\n  transition: all 0.3s ease;\n}\n\n.favorites-btn:hover i {\n  color: white;\n  transform: scale(1.1);\n}\n\n.favorites-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  background: linear-gradient(135deg, #ffc107 0%, #ff8c00 100%);\n  color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: 700;\n  border: 2px solid white;\n  box-shadow: 0 2px 6px rgba(255, 193, 7, 0.4);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n  100% { transform: scale(1); }\n}\n\n.favorites-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 0.75rem;\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: 0;\n  min-width: 320px;\n  max-width: 400px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.favorites-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.favorites-header h6 {\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  font-size: 0.95rem;\n}\n\n.favorites-header .btn-outline-light {\n  border-color: rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.9);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n}\n\n.favorites-header .btn-outline-light:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.5);\n  color: white;\n  transform: scale(1.05);\n}\n\n.favorites-content {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.favorites-list {\n  padding: 0.5rem;\n}\n\n.favorite-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.favorite-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #ffc107, #ff8c00);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.favorite-item:hover {\n  background: rgba(255, 255, 255, 1);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  border-color: rgba(255, 193, 7, 0.3);\n}\n\n.favorite-item:hover::before {\n  opacity: 1;\n}\n\n.favorite-item-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.favorite-item-content h6 {\n  color: #2c3e50;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n  font-size: 0.9rem;\n}\n\n.favorite-item-content .small {\n  font-size: 0.75rem;\n  line-height: 1.3;\n}\n\n.favorite-item-content .badge {\n  font-size: 0.65rem;\n  padding: 0.25rem 0.5rem;\n  font-weight: 600;\n}\n\n.favorite-item-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex-shrink: 0;\n}\n\n.favorite-item-actions .btn {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 0.8rem;\n  transition: all 0.2s ease;\n}\n\n.favorite-item-actions .btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);\n}\n\n.favorite-item-actions .btn-primary:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.4);\n}\n\n.favorite-item-actions .btn-outline-danger {\n  border-color: #dc3545;\n  color: #dc3545;\n  background: rgba(220, 53, 69, 0.05);\n}\n\n.favorite-item-actions .btn-outline-danger:hover {\n  background: #dc3545;\n  color: white;\n  transform: scale(1.1);\n  box-shadow: 0 4px 10px rgba(220, 53, 69, 0.3);\n}\n\n/* Favorites Sections */\n.favorites-section {\n  margin-bottom: 1rem;\n}\n\n.favorites-section:last-child {\n  margin-bottom: 0;\n}\n\n.favorites-section-header {\n  padding: 0.5rem 0.75rem;\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n  border-left: 3px solid;\n}\n\n.favorites-section-header h6 {\n  margin: 0;\n  font-size: 0.85rem;\n  display: flex;\n  align-items: center;\n}\n\n/* Favorite Item Variations */\n.favorite-item-star {\n  border-left: 3px solid #667eea;\n}\n\n.favorite-item-star::before {\n  background: linear-gradient(90deg, #667eea, #764ba2) !important;\n}\n\n.favorite-item-star:hover {\n  border-color: rgba(102, 126, 234, 0.3);\n}\n\n.favorite-item-reserved {\n  border-left: 3px solid #ffc107;\n}\n\n.favorite-item-reserved::before {\n  background: linear-gradient(90deg, #ffc107, #ff8c00) !important;\n}\n\n.favorite-item-reserved:hover {\n  border-color: rgba(255, 193, 7, 0.3);\n}\n\n/* Responsive adjustments */\n@media (max-width: 576px) {\n  .user-account-compact {\n    padding: 0.4rem 0.6rem;\n    gap: 0.5rem;\n  }\n  \n  .avatar-circle-small {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .avatar-circle-small i {\n    font-size: 0.9rem;\n  }\n  \n  .compact-name {\n    font-size: 0.8rem;\n  }\n  \n  .compact-menu-btn {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .compact-menu-btn i {\n    font-size: 0.7rem;\n  }\n\n  .favorites-btn {\n    width: 36px;\n    height: 36px;\n  }\n\n  .favorites-btn i {\n    font-size: 1rem;\n  }\n\n  .favorites-badge {\n    width: 16px;\n    height: 16px;\n    font-size: 0.65rem;\n  }\n\n  .favorites-dropdown-menu {\n    min-width: 280px;\n    max-width: 320px;\n  }\n\n  .favorite-item {\n    padding: 0.6rem;\n    gap: 0.5rem;\n  }\n\n  .favorite-item-content h6 {\n    font-size: 0.85rem;\n  }\n\n  .favorite-item-content .small {\n    font-size: 0.7rem;\n  }\n\n  .favorite-item-actions .btn {\n    width: 28px;\n    height: 28px;\n    font-size: 0.75rem;\n  }\n}\n\n/* Enhanced Dropdown Menu */\n.dropdown-menu {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: 0.75rem;\n  min-width: 220px;\n  margin-top: 0.75rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.dropdown-item {\n  border-radius: 12px;\n  padding: 0.75rem 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  color: var(--text-primary);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.dropdown-item:hover {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);\n  color: var(--primary-color);\n  transform: translateX(4px);\n}\n\n.dropdown-item.text-danger:hover {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%);\n  color: var(--danger-color);\n}\n\n.dropdown-item-text {\n  padding: 0.75rem 1rem;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.02);\n  margin-bottom: 0.25rem;\n}\n\n.dropdown-divider {\n  margin: 0.75rem 0;\n  border-color: var(--border-color);\n  opacity: 0.3;\n  border-radius: 1px;\n}\n\n/* Main Container */\n.main-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  box-shadow: var(--shadow-lg);\n  margin: 20px;\n  min-height: calc(100vh - 40px);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n\n/* Card Styles */\n.card {\n  border: none;\n  border-radius: 16px;\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n}\n\n.card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Gradient Backgrounds */\n.bg-gradient-primary {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.bg-gradient-primary::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n  pointer-events: none;\n}\n\n.bg-gradient-success {\n  background: linear-gradient(135deg, var(--success-color) 0%, #059669 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.bg-gradient-success::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n  pointer-events: none;\n}\n\n.bg-gradient-info {\n  background: linear-gradient(135deg, var(--accent-color) 0%, #0891b2 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.bg-gradient-info::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n  pointer-events: none;\n}\n\n/* Hero Section */\n.hero-section {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n  border-radius: 20px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n/* Metric Cards - Enhanced for better readability and alignment */\n.metric-card {\n  height: 100%;\n  min-height: 200px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.metric-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n/* Provider breakdown styling */\n.provider-breakdown {\n  border-left: 2px solid rgba(255, 255, 255, 0.4);\n  padding-left: 12px;\n  margin-bottom: 8px;\n}\n\n.provider-total {\n  margin-bottom: 6px;\n}\n\n.typology-breakdown {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.typology-breakdown .badge {\n  font-size: 0.7rem;\n  padding: 4px 8px;\n  font-weight: 500;\n}\n\n/* Enhanced metric display */\n.metric-icon {\n  opacity: 0.8;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n}\n\n.metric-number {\n  text-align: right;\n}\n\n.metric-number .display-1 {\n  font-size: 4rem;\n  font-weight: 900;\n  line-height: 1;\n  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.02em;\n}\n\n.metric-number .h5 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  opacity: 0.95;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  letter-spacing: 0.01em;\n}\n\n.metric-breakdown {\n  margin-top: 1rem;\n  font-size: 0.85rem;\n}\n\n.metric-breakdown .badge {\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Content Cards */\n.content-card {\n  height: 100%;\n  min-height: 400px;\n}\n\n.content-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Production App Items */\n.production-app-item {\n  transition: all 0.2s ease;\n  border-radius: 8px;\n}\n\n.production-app-item:hover {\n  background-color: rgba(37, 99, 235, 0.05);\n  transform: translateX(4px);\n}\n\n/* Button Group Enhancements */\n.btn-group .btn {\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.btn-group .btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Card Header Enhancements */\n.card-header {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n  border-bottom: 1px solid rgba(37, 99, 235, 0.1);\n  border-radius: 16px 16px 0 0 !important;\n  padding: 1.5rem;\n}\n\n/* Enhanced Button Styles */\n.btn {\n  border-radius: 12px;\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  border: none;\n  box-shadow: var(--shadow-sm);\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.btn:hover::before {\n  left: 100%;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);\n  color: white;\n  box-shadow: 0 4px 14px 0 rgba(37, 99, 235, 0.3);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, var(--primary-dark) 0%, #1e40af 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px 0 rgba(37, 99, 235, 0.4);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, var(--success-color) 0%, #059669 100%);\n  color: white;\n}\n\n.btn-warning {\n  background: linear-gradient(135deg, var(--warning-color) 0%, #d97706 100%);\n  color: white;\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, var(--danger-color) 0%, #dc2626 100%);\n  color: white;\n}\n\n.btn-outline-light {\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.9);\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n}\n\n.btn-outline-light:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.5);\n  color: white;\n  transform: translateY(-1px);\n}\n\n/* Form Controls */\n.form-control {\n  border-radius: 12px;\n  border: 2px solid var(--border-color);\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n}\n\n.form-control:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n  background: white;\n}\n\n/* Form Labels */\n.form-label {\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n\n/* Breadcrumb */\n.breadcrumb {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 12px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.5rem;\n  backdrop-filter: blur(10px);\n}\n\n.breadcrumb-item a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.breadcrumb-item a:hover {\n  color: var(--primary-dark);\n  text-decoration: underline;\n}\n\n/* Search Results */\n.search-results {\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 16px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n  box-shadow: var(--shadow-md);\n  backdrop-filter: blur(10px);\n}\n\n/* Pipeline Status */\n.pipeline-status {\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.status-running {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--primary-color);\n  border: 1px solid rgba(37, 99, 235, 0.2);\n}\n\n.status-success {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success-color);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.status-failed {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Microsoft Login Button */\n.ms-login-btn {\n  background: #2f2f2f;\n  border: none;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);\n}\n\n.ms-login-btn:hover {\n  background: #1a1a1a;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px 0 rgba(0, 0, 0, 0.3);\n  color: white;\n}\n\n.ms-login-btn img {\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n\n/* Dropdown Enhancements */\n.dropdown {\n  position: relative;\n}\n\n.dropdown-menu {\n  border: none;\n  border-radius: 12px;\n  box-shadow: var(--shadow-lg);\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 0.5rem;\n  min-width: 200px;\n  margin-top: 0.5rem;\n}\n\n.dropdown-item {\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  color: var(--text-primary);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dropdown-item:hover {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--primary-color);\n  transform: translateX(4px);\n}\n\n.dropdown-item.text-danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n}\n\n.dropdown-item-text {\n  padding: 0.5rem 1rem;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.dropdown-divider {\n  margin: 0.5rem 0;\n  border-color: var(--border-color);\n  opacity: 0.5;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .main-container {\n    margin: 10px;\n    border-radius: 16px;\n  }\n  \n  .header-bg .display-6 {\n    font-size: 1.5rem;\n  }\n  \n  .btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n  }\n}\n\n/* Animations */\n.fade-in {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.slide-in {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(0); }\n}\n\n/* Icon Enhancements */\n.bi {\n  vertical-align: middle;\n  line-height: 1;\n}\n\n/* Badge Enhancements */\n.badge {\n  font-weight: 600;\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  letter-spacing: 0.025em;\n}\n\n/* Enhanced Dropdown */\n.dropdown-menu {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 0.5rem;\n  min-width: 200px;\n  margin-top: 0.5rem;\n}\n\n.dropdown-item {\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  color: var(--text-primary);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dropdown-item:hover {\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--primary-color);\n  transform: translateX(4px);\n}\n\n/* Footer */\n.footer {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  border-top: 1px solid var(--border-color);\n  padding: 1rem 0;\n  margin-top: auto;\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(37, 99, 235, 0.3);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(37, 99, 235, 0.5);\n}\n\n/* Smart Navigation Styles */\n.smart-navigation {\n    padding: 0;\n}\n\n.smart-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 2.5rem;\n    border-radius: 1.5rem;\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n    position: relative;\n    overflow: hidden;\n}\n\n.smart-header::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n    pointer-events: none;\n}\n\n.step-info {\n    position: relative;\n    z-index: 2;\n}\n\n.step-icon-wrapper {\n    width: 60px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    backdrop-filter: blur(10px);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.step-info h3 {\n    color: white;\n    margin: 0;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.step-info p {\n    color: rgba(255, 255, 255, 0.8);\n    font-weight: 500;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.progress {\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 2px;\n    overflow: hidden;\n}\n\n.progress-bar {\n    transition: width 0.6s ease;\n    border-radius: 2px;\n}\n\n.step-stats .badge {\n    background: rgba(255, 255, 255, 0.2) !important;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    font-weight: 600;\n    backdrop-filter: blur(10px);\n}\n\n.smart-items-grid {\n    margin-top: 2rem;\n}\n\n.smart-item-card {\n    transition: all 0.3s ease;\n    border-radius: 1.2rem;\n    overflow: hidden;\n    position: relative;\n    background: white;\n    border: 1px solid #e9ecef;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.smart-item-card::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, #667eea, #764ba2);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.smart-item-card:hover::before {\n    opacity: 1;\n}\n\n.smart-item-card:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n}\n\n.icon-wrapper {\n    transition: all 0.3s ease;\n    border: 2px solid rgba(0, 0, 0, 0.05);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.smart-item-card:hover .icon-wrapper {\n    transform: scale(1.1);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n.metadata-badges {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.4rem;\n    margin: 1rem 0;\n}\n\n.metadata-badges .badge {\n    font-weight: 600;\n    padding: 0.5rem 0.8rem;\n    border-radius: 20px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n    line-height: 1.2;\n    letter-spacing: 0.02em;\n}\n\n.metadata-badges .badge:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n/* Version badge container for better organization */\n.version-badge-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.version-badge-container .badge {\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: help;\n}\n\n.loading-container {\n    background: white;\n    border-radius: 1.2rem;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e9ecef;\n}\n\n.empty-state {\n    background: white;\n    border-radius: 1.2rem;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n    border: 2px dashed #e9ecef;\n}\n\n.empty-state i {\n    color: #adb5bd;\n}\n\n/* Enhanced card body styling */\n.smart-item-card .card-body {\n    padding: 1.25rem;\n}\n\n.smart-item-card h5 {\n    color: #2c3e50;\n    font-weight: 700;\n    margin-bottom: 0.75rem;\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.smart-item-card h5 .badge {\n    font-size: 0.6rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 12px;\n    font-weight: 600;\n    vertical-align: middle;\n}\n\n.smart-item-card .text-muted {\n    color: #6c757d !important;\n    font-weight: 500;\n    line-height: 1.4;\n    margin-bottom: 1rem;\n}\n\n/* Compact version info styling */\n.version-info-compact {\n    margin: 0.75rem 0;\n}\n\n.version-info-compact .badge {\n    font-size: 0.6rem;\n    padding: 0.2rem 0.4rem;\n    border-radius: 12px;\n    font-weight: 500;\n    box-shadow: none;\n    border: 1px solid #dee2e6;\n    background-color: #f8f9fa;\n    color: #6c757d;\n    transition: all 0.2s ease;\n}\n\n.version-info-compact .badge:hover {\n    background-color: #e9ecef;\n    border-color: #adb5bd;\n    transform: none;\n    box-shadow: none;\n}\n\n/* Improved reservation status styling - More Prominent */\n.reservation-status {\n    margin-bottom: 1rem;\n    padding: 0.5rem;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.02);\n}\n\n.reserved-badge {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.reserved-badge .badge {\n    font-size: 0.75rem;\n    padding: 0.5rem 0.8rem;\n    font-weight: 700;\n    border-radius: 25px;\n    box-shadow: 0 3px 8px rgba(255, 193, 7, 0.3);\n}\n\n.reserved-badge small {\n    font-size: 0.7rem;\n    opacity: 0.9;\n    font-weight: 600;\n    color: #495057;\n}\n\n/* Enhanced button styling - Primary Actions Most Prominent */\n.smart-item-card .btn {\n    transition: all 0.2s ease;\n    border-radius: 8px;\n    font-weight: 700;\n    padding: 0.5rem 1rem;\n    font-size: 0.8rem;\n    letter-spacing: 0.02em;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Primary action buttons (Deploy/Select) - Most prominent */\n.smart-item-card .btn-primary,\n.smart-item-card .btn-success,\n.smart-item-card .btn-warning,\n.smart-item-card .btn-info {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n    font-weight: 800;\n    padding: 0.6rem 1.2rem;\n    font-size: 0.85rem;\n}\n\n/* Secondary action buttons (Reserve/Release) - Clear but not dominant */\n.smart-item-card .btn-outline-primary,\n.smart-item-card .btn-outline-secondary {\n    font-weight: 600;\n    padding: 0.5rem 1rem;\n    font-size: 0.75rem;\n    border-width: 1.5px;\n}\n\n/* Tertiary action buttons (Mute) - Subtle */\n.smart-item-card .btn-outline-danger {\n    font-weight: 500;\n    padding: 0.4rem 0.8rem;\n    font-size: 0.7rem;\n    border-width: 1px;\n    opacity: 0.8;\n}\n\n.smart-item-card .btn-outline-danger:hover {\n    opacity: 1;\n    transform: translateY(-1px);\n    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);\n}\n\n.smart-item-card .btn:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Smart header button improvements */\n.smart-header .btn {\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    color: white;\n    transition: all 0.3s ease;\n    position: relative;\n    z-index: 2;\n}\n\n.smart-header .btn:hover {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.5);\n    color: white;\n    transform: scale(1.05);\n}\n\n/* Improved reserved app styling */\n.smart-item-card.reserved-app {\n    border: 2px solid #ffc107 !important;\n    background: linear-gradient(135deg, rgba(255, 193, 7, 0.05) 0%, rgba(255, 193, 7, 0.02) 100%);\n    box-shadow: 0 6px 20px rgba(255, 193, 7, 0.15);\n}\n\n.smart-item-card.reserved-app::before {\n    background: linear-gradient(90deg, #ffc107, #ff8c00) !important;\n    opacity: 1 !important;\n}\n\n.smart-item-card.reserved-app .icon-wrapper {\n    border-color: #ffc107;\n    background-color: rgba(255, 193, 7, 0.1) !important;\n    box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);\n}\n\n.smart-item-card.reserved-app .icon-wrapper i {\n    color: #ffc107 !important;\n}\n\n.smart-item-card.reserved-app:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 15px 35px rgba(255, 193, 7, 0.25);\n}\n\n/* Loading spinner improvements */\n.spinner-border-sm {\n    width: 0.875rem;\n    height: 0.875rem;\n    border-width: 0.125rem;\n}\n\n/* Responsive improvements */\n@media (max-width: 768px) {\n    .smart-header {\n        padding: 1.5rem;\n    }\n    \n    .smart-item-card {\n        margin-bottom: 1rem;\n    }\n    \n    .icon-wrapper {\n        width: 60px !important;\n        height: 60px !important;\n    }\n    \n    .step-info h3 {\n        font-size: 1.25rem;\n    }\n    \n    .step-info p {\n        font-size: 0.9rem;\n    }\n    \n    .smart-item-card .card-body {\n        padding: 1rem;\n    }\n    \n    .metadata-badges {\n        gap: 0.3rem;\n    }\n    \n    .metadata-badges .badge {\n        font-size: 0.65rem;\n        padding: 0.4rem 0.6rem;\n    }\n    \n    .smart-item-card .btn {\n        font-size: 0.75rem;\n        padding: 0.4rem 0.8rem;\n    }\n    \n    .smart-item-card .btn-primary,\n    .smart-item-card .btn-success,\n    .smart-item-card .btn-warning,\n    .smart-item-card .btn-info {\n        font-size: 0.8rem;\n        padding: 0.5rem 1rem;\n    }\n    \n    .reserved-badge .badge {\n        font-size: 0.7rem;\n        padding: 0.4rem 0.7rem;\n    }\n    \n    .d-flex.flex-wrap {\n        gap: 0.5rem !important;\n    }\n    \n    .btn-sm {\n        font-size: 0.7rem;\n        padding: 0.25rem 0.5rem;\n    }\n}\n\n/* App Type Filter Toggle Styles */\n.btn-group .btn-check:checked + .btn-outline-primary {\n    background-color: var(--primary-color);\n    border-color: var(--primary-color);\n    color: white;\n    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);\n}\n\n.btn-group .btn-outline-primary {\n    border-color: var(--border-color);\n    color: var(--text-secondary);\n    transition: all 0.2s ease;\n}\n\n.btn-group .btn-outline-primary:hover {\n    background-color: rgba(37, 99, 235, 0.1);\n    border-color: var(--primary-color);\n    color: var(--primary-color);\n}\n\n.btn-group .btn-outline-primary:active {\n    transform: scale(0.98);\n}\n\n/* Navigation App Type Filter Toggle Styles */\n.smart-header .btn-group .btn-check:checked + .btn-outline-light {\n    background-color: rgba(255, 255, 255, 0.3);\n    border-color: rgba(255, 255, 255, 0.5);\n    color: white;\n    box-shadow: 0 2px 4px rgba(255, 255, 255, 0.2);\n}\n\n.smart-header .btn-group .btn-outline-light {\n    border-color: rgba(255, 255, 255, 0.3);\n    color: rgba(255, 255, 255, 0.8);\n    transition: all 0.2s ease;\n    font-size: 0.75rem;\n    padding: 0.375rem 0.75rem;\n}\n\n.smart-header .btn-group .btn-outline-light:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.5);\n    color: white;\n}\n\n.smart-header .btn-group .btn-outline-light:active {\n    transform: scale(0.98);\n}\n\n/* Chart Styles */\n.chart-container {\n    position: relative;\n    width: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.chart-container canvas {\n    border-radius: 8px;\n}\n\n.metric-card .chart-container {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Sophisticated Metric Card Design */\n.metric-card {\n    position: relative;\n    overflow: hidden;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    border: none;\n}\n\n.metric-card:hover {\n    transform: translateY(-8px) scale(1.02);\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.metric-card-bg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    opacity: 0.7;\n    transition: all 0.4s ease;\n}\n\n.metric-card:hover .metric-card-bg {\n    opacity: 1;\n    transform: scale(1.05);\n}\n\n.metric-card-content {\n    position: relative;\n    z-index: 2;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.metric-header {\n    flex-shrink: 0;\n}\n\n.metric-breakdown {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    gap: 0.75rem;\n}\n\n/* Alignement uniforme des éléments */\n.metric-icon-wrapper {\n    width: 80px;\n    height: 80px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.metric-number {\n    text-align: right;\n    min-width: 120px;\n}\n\n.metric-number .display-3 {\n    font-size: 3rem;\n    line-height: 1;\n    margin-bottom: 0.25rem;\n}\n\n.metric-number .h6 {\n    font-size: 0.875rem;\n    margin-bottom: 0;\n}\n\n/* Alignement des sections de breakdown */\n.breakdown-section {\n    margin-bottom: 0.75rem !important;\n}\n\n.breakdown-section:last-child {\n    margin-bottom: 0 !important;\n}\n\n/* Alignement des compteurs */\n.metric-counter {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 60px;\n    padding: 0.5rem;\n}\n\n.metric-counter .h6 {\n    margin-bottom: 0.25rem;\n    font-size: 1rem;\n    font-weight: 700;\n}\n\n.metric-counter .small {\n    font-size: 0.75rem;\n    margin-bottom: 0;\n    font-weight: 600;\n}\n\n/* Espacement uniforme des grilles */\n.metric-breakdown .row {\n    margin: 0;\n}\n\n.metric-breakdown .col-4 {\n    padding: 0 0.25rem;\n}\n\n.metric-icon-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.15);\n    backdrop-filter: blur(10px);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    transition: all 0.3s ease;\n}\n\n.metric-card:hover .metric-icon-wrapper {\n    background: rgba(255, 255, 255, 0.25);\n    border-color: rgba(255, 255, 255, 0.4);\n    transform: scale(1.1);\n}\n\n.metric-icon-wrapper i {\n    color: white;\n    font-size: 2.5rem;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    transition: all 0.3s ease;\n}\n\n.metric-card:hover .metric-icon-wrapper i {\n    transform: scale(1.1);\n}\n\n/* Card-specific variations - Professional Theme */\n.metric-card-deployments .metric-card-bg {\n    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n}\n\n.metric-card-providers .metric-card-bg {\n    background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n}\n\n.metric-card-apps .metric-card-bg {\n    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);\n}\n\n/* Enhanced metric display */\n.metric-number .display-1 {\n    font-size: 4.5rem;\n    font-weight: 900;\n    line-height: 1;\n    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n    margin-bottom: 0.5rem;\n    letter-spacing: -0.02em;\n    background: linear-gradient(45deg, #ffffff, #f0f0f0);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.metric-number .h5 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    opacity: 0.95;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    letter-spacing: 0.01em;\n}\n\n/* Metric breakdown styling */\n.metric-breakdown {\n    margin-top: 1.5rem;\n    font-size: 0.85rem;\n}\n\n.breakdown-section {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease;\n}\n\n.breakdown-section:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n    background: rgba(255, 255, 255, 1) !important;\n}\n\n.metric-counter {\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.metric-counter:hover {\n    transform: scale(1.05);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
